import { useQuery } from "@tanstack/react-query"
import { getRfqBuyerToAdminWithQuotations } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetRfqBuyerToAdminWithQuotations(id: string) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["buyer-rfq-with-quotations", id],
    queryFn: () => getRfqBuyerToAdminWithQuotations(id, accessToken!),
    enabled: !!accessToken && !!id,
    staleTime: 0,
  })
}
